import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {useParams} from 'react-router-dom';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = () => {

    // Steps are always rendered inside the `/playbooks/:id/phases/:phaseId`
    // scope — pull both params from the route so the table can filter.
    const {id: playbookId, phaseId} = useParams();

    if (typeof playbookId === 'undefined') {
        throw new Error('playbookId (from route param :id) is required to list steps');
    }

    if (typeof phaseId === 'undefined') {
        throw new Error('phaseId (from route param :phaseId) is required to list steps');
    }

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
